/** A keyboard-shortcut chip that sits inside a button, after its label. Inherits the
 *  button's text colour so it reads on both filled and outlined buttons. */
export function KeyHint({ keys }: { keys: string }) {
  return (
    <kbd
      aria-hidden
      style={{
        marginLeft: 8,
        padding: '1px 5px',
        borderRadius: 4,
        fontFamily: 'var(--font-mono, ui-monospace)',
        fontSize: 10.5,
        fontWeight: 500,
        lineHeight: 1.4,
        color: 'inherit',
        background: 'rgba(255, 255, 255, 0.18)',
        border: '1px solid rgba(255, 255, 255, 0.28)',
      }}
    >
      {keys}
    </kbd>
  );
}
